import React from "react";
import Loading from "components/drawerLoading";
import dayjs from "dayjs";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";
import VehicleStatusIcon from "./VehicleStatus";

const EventsHistory = ({ data, drawerIsLoading }): JSX.Element => {
  const LIST_OF_SENT_AND_RECEIVED_EVENTS = useTranslation({ id: "list_of_sent_and_received_events" });
  const NO_EVENT_REGISTERED = useTranslation({ id: "no_event_registered" });

  return (
    <Loading show={drawerIsLoading}>
      <S.Title>{LIST_OF_SENT_AND_RECEIVED_EVENTS}</S.Title>
      {data.length > 0 ? (
        data.map((item, index) => (
          <React.Fragment key={index}>
            <VehicleStatusIcon vehicleStatus={item.status} title={item.statusDescription} />
            <S.DescriptionContainer>
              <S.SubTitle>{`${item.description}${"\xa0"}`}</S.SubTitle>
              <S.Description>{`${dayjs.utc(item.eventTime).local().format("DD/MM/YYYY HH:mm")}`}</S.Description>
            </S.DescriptionContainer>
            <S.Details>{item.details}</S.Details>
          </React.Fragment>
        ))
      ) : (
        <S.WithoutEventsContainer>
          <S.SubTitleNoEvent>{NO_EVENT_REGISTERED}</S.SubTitleNoEvent>
        </S.WithoutEventsContainer>
      )}
    </Loading>
  );
};

export default EventsHistory;
